import { render, staticRenderFns } from "./SetHistory.vue?vue&type=template&id=3377b38a&"
import script from "./SetHistory.vue?vue&type=script&lang=js&"
export * from "./SetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VListGroup})
